<template>
  <div> <!-- Element rădăcină -->
    <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('gestiune.entries')"></general-top-bar> -->
      <div id="outer-container">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                  <div class="clearfix row pad-lf-10 pad-rg-10">
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isEntries }"
                        @click="openEntries"
                      >{{$t('gestiune.docFurnizori')}}</a>
                      <a
                        class="btn btn-fill btn-primary"
                        :class="{ active: isInvoiceSupplier }"
                        @click="openInvoiceSupplier"
                      >{{$t('invoice.invoiceSupplier')}}</a>
                  </div>
              </div>
          </div>
      </div>
      <div v-if="isEntries">
        <ManagementEntries :groupedLocations="groupedLocations"/>
      </div>
      <div v-if="isInvoiceSupplier">
        <ManagementInvoiceSupplier :groupedLocations="groupedLocations"/>
      </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import ManagementEntries from 'src/components/Dashboard/Views/Management/Entries/ManagementEntries.vue'
  import ManagementInvoiceSupplier from 'src/components/Dashboard/Views/Management/Entries/ManagementInvoiceSupplier.vue'

  export default {
    components: {
      // GeneralTopBar,
      ManagementEntries,
      ManagementInvoiceSupplier
    },
    data () {
      return {
        isEntries: true,
        isInvoiceSupplier: false
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      }
    },
    methods: {
      openEntries () {
        this.isEntries = true
        this.isInvoiceSupplier = false
      },
      openInvoiceSupplier () {
        this.isInvoiceSupplier = true
        this.isEntries = false
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementEntriesTabs.vue